
import TextInput from '@/mixins/TextInput';

export default {
  name: 'AppSearchInputPc',
  mixins: [TextInput],
  methods: {
    reset() {
      this.change(null);
      this.submit();
    },
    submit() {
      this.$emit('submit', this.currentValue);
    },
    focus() {
      this.$refs.input.focus();
    }
  }
};
